import { render, staticRenderFns } from "./merchants-add.vue?vue&type=template&id=322071d2&scoped=true&"
import script from "./merchants-add.vue?vue&type=script&lang=js&"
export * from "./merchants-add.vue?vue&type=script&lang=js&"
import style0 from "./merchants-add.vue?vue&type=style&index=0&id=322071d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322071d2",
  null
  
)

export default component.exports